module.exports = __webpack_public_path__ + "static/media/telemedicineDoctor.6d281e2c.png";